<template>
  <div style="width: 100%;display: flex;">
    <div style="width: 25%;background-color: #333333;"></div>
    <div style="width: 50%;">
      <div style="position: fixed;z-index: 100;margin-left: 20%;top: 0;">
        <el-button-group>
          <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>
          <el-button type="primary" size="mini" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </el-button-group>
        <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>
      </div>
      <div style="margin-top: 10px;">
        <pdf
          :page="pageNum"
          :src="url"
          @progress="loadedRatio = $event"
          @num-pages="pageTotalNum=$event"
          ></pdf>
      </div>
    </div>
    <div style="width: 25%;background-color: #333333;"></div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'ReportDetail',
  components: {
    pdf
  },
  data() {
    return {
      url: '',
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0
    }
  },
  created() {
    this.url = this.$route.query.url
  },
  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/FormManage/ReportDetail.vue